import { memoize } from 'lodash';

import { ShortIdCompress } from 'common/short-id-compress';

export const extractCachedCompareState = memoize(
  (compressed: string, projectKey: string): string[] => {
    return ShortIdCompress.parse(compressed, projectKey);
  },
  (...args) => args.join('#'),
);
